import { render, staticRenderFns } from "./UserSwitchTabs.vue?vue&type=template&id=43b70b6c&scoped=true&"
import script from "./UserSwitchTabs.vue?vue&type=script&lang=js&"
export * from "./UserSwitchTabs.vue?vue&type=script&lang=js&"
import style0 from "./UserSwitchTabs.vue?vue&type=style&index=0&id=43b70b6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b70b6c",
  null
  
)

export default component.exports